export default {
  data() {
    return {
      _unsaved: true
    };
  },
  beforeDestroy() {
    window.onbeforeunload = null;
  },
  mounted() {
    window.onbeforeunload = () =>
      this._unsaved ? "Tem certeza que deseja sair?" : "";
  }
};
